import { fetchToken } from "../../../../../common/FetchCookie"
import { BASE_URL, EMPLOYER, EMPLOYER_SAVED_CANDIDATE } from "../../../../../common/URLs"

export const addEmployerSavedCandidate = async (candidate_uuid) => {
    const url = `${BASE_URL}/${EMPLOYER}/${EMPLOYER_SAVED_CANDIDATE}`;
    try {
        const token = await fetchToken();
        const response = await fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ candidate_uuid }), // ✅ now this has a value
        });
        const data = await response.json();
        return data;
    } catch (error) {
        throw error;
    }
};
export const removeEmployerSavedCandidate = async (candidate_uuid) => {
    const url = `${BASE_URL}/${EMPLOYER}/${EMPLOYER_SAVED_CANDIDATE}`;
    try {
        const token = await fetchToken();
        const response = await fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ candidate_uuid }), // ✅ now this has a value
        });
        const data = await response.json();
        return data;
    } catch (error) {
        throw error;
    }
};


// EmployerSaveCandidateAPI.js
export const fetchEmployerSavedCandidate = async (page = 1, perPage = 10) => {
    const url = `${BASE_URL}/${EMPLOYER}/${EMPLOYER_SAVED_CANDIDATE}-v2?page=${page}&per_page=${perPage}`;
    try {
        const token = await fetchToken();
        const response = await fetch(url, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        const data = await response.json();
        return data;
    } catch (error) {
        throw error;
    }
};